@if (group) {
  <div class="boton-form" [formGroup]="group">
    <div class="fila">
      <mat-form-field appearance="outline" class="f-nombre">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="nombre" placeholder="Ej. Pánico" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="f-variante">
        <mat-label>Variante</mat-label>
        <input matInput formControlName="variante" placeholder="Ej. Default" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="f-funcion">
        <mat-label>Funcionalidad</mat-label>
        <mat-select formControlName="funcion">
          @for (f of funciones; track f) {
            <mat-option [value]="f">{{ f }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Condicionales por función -->
    @if (funcion === 'Menu') {
      <mat-form-field appearance="outline" class="full">
        <mat-label>Grupo destino (a qué página navega)</mat-label>
        <mat-select formControlName="grupoDestino">
          @for (g of gruposBotones; track g) {
            <mat-option [value]="g">{{ g }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (funcion === 'Link') {
      <mat-form-field appearance="outline" class="full">
        <mat-label>Link (URL)</mat-label>
        <input matInput formControlName="link" placeholder="https://..." />
      </mat-form-field>
    }

    @if (funcion === 'Telemedicina') {
      <mat-form-field appearance="outline" class="full">
        <mat-label>URL Telemedicina</mat-label>
        <input matInput formControlName="telemedicina" placeholder="https://..." />
      </mat-form-field>
    }

    <!-- Aspecto del botón: imagen o texto+color -->
    <div class="aspecto">
      <div class="aspecto-imagen">
        <span class="sub">Imagen</span>
        <span class="hint">📐 {{ hint || 'Elegí la botonera para ver el tamaño' }}</span>
        <div class="img-row">
          @if (group.get('urlImagen')?.value) {
            <img class="thumb" [src]="group.get('urlImagen')?.value" alt="botón" />
          }
          <button
            mat-stroked-button
            type="button"
            (click)="fileInput.click()"
            [disabled]="loading"
          >
            <mat-icon>upload</mat-icon> Subir imagen
          </button>
          @if (group.get('urlImagen')?.value) {
            <button mat-icon-button type="button" (click)="limpiarImagen()">
              <mat-icon>delete</mat-icon>
            </button>
          }
          <input
            #fileInput
            type="file"
            accept="image/*"
            hidden
            (change)="setFile($event, 'urlImagen')"
          />
        </div>
        @if (group.get('urlImagen')?.value) {
          <span class="hint">
            Presionado (opcional): se ve mientras se mantiene apretado. Sin ella,
            la app oscurece la imagen.
          </span>
          <div class="img-row">
            @if (group.get('urlImagenPush')?.value) {
              <img
                class="thumb"
                [src]="group.get('urlImagenPush')?.value"
                alt="botón presionado"
              />
            }
            <button
              mat-stroked-button
              type="button"
              (click)="fileInputPush.click()"
              [disabled]="loading"
            >
              <mat-icon>touch_app</mat-icon> Imagen presionado
            </button>
            @if (group.get('urlImagenPush')?.value) {
              <button
                mat-icon-button
                type="button"
                (click)="limpiarImagen('urlImagenPush')"
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
            <input
              #fileInputPush
              type="file"
              accept="image/*"
              hidden
              (change)="setFile($event, 'urlImagenPush')"
            />
          </div>
        }
      </div>

      <div class="aspecto-texto">
        <span class="sub">o Texto + color (si no hay imagen)</span>
        <div class="fila">
          <mat-form-field appearance="outline" class="f-texto">
            <mat-label>Texto</mat-label>
            <input matInput formControlName="texto" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="f-color">
            <mat-label>Color</mat-label>
            <input matInput formControlName="color" readonly />
            <ngx-colors
              matSuffix
              ngx-colors-trigger
              formControlName="color"
              (change)="onColorChange($event, 'color')"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <!-- Extras opcionales -->
    <div class="fila extras">
      <mat-form-field appearance="outline" class="f-prioridad">
        <mat-label>Prioridad</mat-label>
        <input matInput type="number" formControlName="prioridad" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f-notif">
        <mat-label>Notificación</mat-label>
        <mat-select formControlName="notificacion">
          @for (n of notificaciones; track n) {
            <mat-option [value]="n">{{ n }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-checkbox formControlName="global">Global (fuera de zona)</mat-checkbox>
    </div>
  </div>
}
